/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,setRevise} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { getDateTime } from "../../common"
import { toast } from 'react-toastify';
import OrderHeader from "../IndexSections/OrderHeader.js";


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Product from "../IndexSections/Product.js";
import { Badge } from "reactstrap";




function Index(props) {
  // const [state, setState] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [approvedPrice, setApprovedPrice] = useState(0);
  const main = useRef();
  const [orderId, setOrderId] = useState(null);
  const [memoNote, setMemoNote] = useState("");
  const [noteModal, setNoteModal] = useState(false);
  const [newMemoNote, setNewMemoNote] = useState("");
  

  const toggleNote = () => setNoteModal(!noteModal);
  
  const toggleAddProduct = () => {
    console.log("toggle");
    setOpenAddProduct(!openAddProduct);
  }
  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group      
              }        
            }
            category['items'] = items;
            categories[key] = category;
          }
          setApprovedPrice((quote.approved_price*1).toFixed(2));
          setDiscount((quote.discount*1).toFixed(2))
          setMemoNote(quote.memo_note)
          var init_quote = {
            user_id: quote.user_id?quote.user_id:null,         
            categories: categories,
            selectedContactUser: quote.contact_user?quote.contact_user:null,            
            selectedContactAddress: quote.contact_address?quote.contact_address:null,
            selectedContactInfo: quote.contact_info?quote.contact_info:null,
            validDate: quote.valid_to?quote.valid_to:null,
            delivery_required: quote.delivery_required?quote.delivery_required:null,
            id: quote.id?quote.id:null,
            revision: quote.revision?quote.revision:null,
            quoteLabel: quote.label,
            clientLabel: quote.client_label,
            defaultBrand: quote.default_brand,
            created_at: quote.created_at,
            wfm_order_no: quote.wfm_order_no
          };
          props.setQuote(init_quote)
        }
    }) 
    setOrderId(id) 
  },[]);

  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    if(categories[0]){
      const category = categories[0]
      elements.push(
        <Category history={props.history} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory}/>
      )
    }
    else{
      elements.push(
        <Category history={props.history} category={null} state={[]} groups={[]} updateCategory={props.updateCategory}/>
      )
    }

    return elements;
  }


  const submitOrder=async()=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      delivery_required
    } = props.quote;
    var quote = props.quote;
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    var bodyFormData = new FormData();
    bodyFormData.append('content', JSON.stringify(categories));
    bodyFormData.append('order_status', "Completed Order");
    bodyFormData.append('approved_price', approvedPrice);
    bodyFormData.append('discount', discount);
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('updated_at',getDateTime())
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('client_label',quote.clientLabel?quote.clientLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")  
    bodyFormData.append('default_brand',quote.defaultBrand?quote.defaultBrand:"") 
    bodyFormData.append('wfm_order_no',quote.wfm_order_no?quote.wfm_order_no:"") 
    if(logoImage)
      bodyFormData.append('logo', logoImage);

    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The order has been completed");
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  const addMemo =async()=>{
    var bodyFormData = new FormData();
    bodyFormData.append('memo_note', newMemoNote);

    axios.post(`/quotes/addmemo/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        setMemoNote(result.data)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  
  const getMemoCount = (memo)=>{
    if(!memo) return 0
    const  newstrings = memo.split("\n"); 
    return newstrings.length;
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">              
              <OrderHeader/>
              {
                renderCategory()
              }
              <Row style={{marginTop:'60px'}}>
                <Col lg="6">
                </Col>
                <Col lg="6">
                  <div className="d-flex" style={{justifyContent:'flex-end'}}>
                    <FormGroup className="text-center">
                      <Label><strong>Approve price</strong></Label>
                      <div className="d-flex align-items-center">
                      $&nbsp;<Input placeholder="Total" value={approvedPrice} onChange={(e)=>setApprovedPrice(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label><strong>Discount</strong></Label>
                      <div className="d-flex align-items-center">
                        $&nbsp;<Input placeholder="Discount" value={discount} onChange={(e)=>setDiscount(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label className="d-block"><strong>Total</strong></Label>
                      <Label className="mt-2">$&nbsp;<strong>{(parseFloat(approvedPrice) - parseFloat(discount)).toFixed(2)}</strong></Label>
                    </FormGroup>
                  </div>
                </Col>
                
              </Row>
              <div className="order-nav" style={{marginTop:'60px'}}>
                <div>
                  <Button
                    // onClick={() => {
                    //   setState([...state, []]);
                    // }}
                    onClick={toggleAddProduct}
                    className="btn-icon btn-3" color="primary" type="button">
                    <span className="btn-inner--text">ADD CATALOGUE</span>
                  </Button>    
                </div>
                <div>                  
                  <Button
                    onClick={submitOrder}
                    className="btn-icon btn-3" color="primary" type="button">
                    <span className="btn-inner--text">Finalise ORDER</span>
                  </Button>
                  <Button
                    onClick={()=>setNoteModal(true)}
                    className="btn-icon btn-3" color="primary" type="button">
                    <i style={{fontSize:20}} className="fa fa-commenting-o" aria-hidden="true"></i>
                      <Badge className="badge-white m-0">{getMemoCount(memoNote)}</Badge>
                  </Button>
                </div>
              </div>
              {openAddProduct &&
              <Product isOpen={openAddProduct} category={null} toggle = {toggleAddProduct}
                onAdd={(items, categoryInfo) => {
                  var state=[]
                  var categories = {...props.quote.categories}
                  var category = null
                  for(var catInd in categories){
                    var category = {...categories[catInd]}
                    break;
                  }
                  if(category)
                    state = [...category.items]
                  var newitems = [...items]
                  for(var loop = 0; loop < newitems.length; loop++){
                    var newitem = {...newitems[loop]}
                    newitem['productid'] = newitem['id']
                    var itemCount = 0;
                    for(var loop1 = 0; loop1< state.length; loop1++){
                      itemCount+= state[loop1].length;
                    }
                    newitem['id'] = (loop + itemCount + 1).toString()
                    newitems[loop] = newitem
                  }
                  var newstate = [...state, newitems];
                  console.log("newstate", newstate)
                  // setState(newstate);
                  toggleAddProduct();
                  var cat_val={
                    [0]:{
                      category_info: categoryInfo,
                      items: newstate
                    }
                  }
                  props.updateCategory(cat_val)
                }}
              />
              }
            </Col>
            {/* <Col  md="3">
              <div style={{margin:'100px auto', width:'150px'}}>
                {logoImage?
                  <img width="100%" height="auto"
                    src={logoImage}/>:
                  <div className="empty-logo">YOUR<br/>LOGO</div>
                }
                <div className="mt-4 text-center">
                  <Button onClick={()=>{logoRef.current.click()}} className="" color="white" outline type="button" size={'sm'} style={{width:'140px'}}>
                    UPLOAD LOGO
                  </Button>
                </div>
                <div className="mt-2 text-center">
                  <Button onClick={toggleCustomiseLogo} className={customiseLogo?"toggle active":"toggle"} color="white" outline type="button" size={'sm'} style={{width:'140px'}}>
                    CUSTOMISE LOGO
                  </Button>
                </div>
                <div className="mt-2 text-center">
                  <Button onClick={repeatOrder} className="" color="white" outline type="button" size={'sm'} style={{width:'140px'}}>
                    PAST ORDERS
                  </Button>
                </div>
              </div>
            </Col> */}
          </Row>
          <Modal isOpen={noteModal} toggle={toggleNote} size="md">
            <ModalHeader toggle={toggleNote}>
              <h3 className="h4 font-weight-bold mb-0">
                Conversation Log
              </h3>
            </ModalHeader>
            <ModalBody>
                  <FormGroup>
                    <Input style={{whitespace: 'pre-line'}} disabled type="textarea" rows="8" value={memoNote?memoNote:""}/>                    
                  </FormGroup>
                  <FormGroup>
                    <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)}/>
                  </FormGroup>
                  <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                    <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                    <Button color="secondary" onClick={toggleNote}>Cancel</Button>
                  </div>
            </ModalBody>       
          </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
